import { Flex } from "@chakra-ui/react";
import { KanbanColumn, type KanbanColumnData } from "./KanbanColumn";
import type { Candidate } from "../../../../types/onboarding";
import type { WhitelistEntry } from "../../../../types/whitelist";

export interface KanbanProps {
  columns: KanbanColumnData[];
  selectedCandidateIds: Set<string | number>;
  onToggleSelect?: (candidateId: string | number) => void;
  onViewDetail: (candidate: Candidate) => void;
  onCancel: (candidate: Candidate) => void;
  onReactivate: (candidate: Candidate) => void;
  showHrProgress?: boolean;
  whitelistMap?: Record<string, WhitelistEntry>;
}

/** Board de Kanban: colunas lado a lado, crescendo para preencher a largura
 * disponível (até um teto) e centralizadas quando sobra espaço; com scroll
 * horizontal quando não há espaço suficiente. Cada coluna pagina/busca de
 * forma independente (ver KanbanColumn + useInfiniteSectionScroll). */
export const Kanban = ({
  columns, selectedCandidateIds, onToggleSelect, onViewDetail, onCancel, onReactivate,
  showHrProgress, whitelistMap,
}: KanbanProps) => {
  return (
    // Colunas encolhem (flex-shrink) para sempre caber na largura disponível
    // — nunca gera scroll horizontal na página, independentemente de quantas
    // colunas existam.
    <Flex gap={3} align="flex-start" overflow="hidden" w="100%" h="100%" pb={2}>
      {columns.map(({ key, ...col }) => (
        <KanbanColumn
          key={key}
          {...col}
          selectedCandidateIds={selectedCandidateIds}
          onToggleSelect={onToggleSelect}
          onViewDetail={onViewDetail}
          onCancel={onCancel}
          onReactivate={onReactivate}
          showHrProgress={showHrProgress}
          whitelistMap={whitelistMap}
        />
      ))}
    </Flex>
  );
};
